// src/services/authServices.js
import { backend } from "../utils/axiosinstance";

// ============================================
// 🔐 احراز هویت OTP (ورود)
// ============================================

/**
 * درخواست کد تایید برای ورود
 */
export const requestOtp = (phone) => {
  return backend.post("/api/v1/users/request-otp/", { phone });
};

/**
 * تایید کد و دریافت توکن JWT (ورود)
 */
export const verifyOtp = (phone, code) => {
  return backend.post("/api/v1/users/verify-otp/", { phone, code });
};

/**
 * تنظیم نام کاربری (برای کاربران جدید)
 */
export const setUsername = (data, { userInfo, dispatch }) => {
  const { authAxiosInstance } = require("../utils/axiosinstance");
  const authBackend = authAxiosInstance(userInfo, dispatch);
  return authBackend.post("/api/v1/users/set-username/", data);
};

/**
 * رفرش توکن JWT
 */
export const tokenRefresh = (data) => {
  return backend.post("/api/v1/users/token/refresh/", data);
};


// ============================================
// 📱 تغییر شماره تلفن (NEW)
// ============================================

/**
 * مرحله 1: درخواست تغییر شماره تلفن
 * ارسال کد تایید به شماره فعلی
 */
export const requestPhoneChange = (newPhone, { userInfo, dispatch }) => {
  const { authAxiosInstance } = require("../utils/axiosinstance");
  const authBackend = authAxiosInstance(userInfo, dispatch);
  return authBackend.post("/api/v1/users/request-phone-change/", { new_phone: newPhone });
};

/**
 * مرحله 2: تایید کد و اعمال تغییر شماره
 */
export const verifyPhoneChange = (code, { userInfo, dispatch }) => {
  const { authAxiosInstance } = require("../utils/axiosinstance");
  const authBackend = authAxiosInstance(userInfo, dispatch);
  return authBackend.post("/api/v1/users/verify-phone-change/", { code });
};